import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link, Outlet, useLocation } from 'react-router-dom';
import styles from './App.module.scss';

function App() {
    const location = useLocation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <div className="App">
            <div className={styles.menu}>
                {/* <div style={{ float: 'right', marginTop: 18, marginRight: 14 }}>
                <BurgerMenu />
            </div> */}
                <h1 style={{ paddingTop: 10, paddingLeft: 10, color: '#928d00ff' }}>
                    <img style={{ width: '31px', paddingRight: 5 }} src="/logo_plain_opti.svg" alt="logo" />
                    Ølgolf
                </h1>
                <div style={{ clear: 'both', marginLeft: 24 }}>
                    <ul>
                        <li><Link className={location.pathname === '/' ? styles.active : null} to="/">2025</Link></li>
                        <li>
                            <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                Vælg år
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={handleClose}><Link to="/">2025</Link></MenuItem>
                                <MenuItem onClick={handleClose}><Link to="2024">2024</Link></MenuItem>
                                <MenuItem onClick={handleClose}><Link to="2023">2023</Link></MenuItem>
                                <MenuItem onClick={handleClose}><Link to="2022">2022</Link></MenuItem>
                                <MenuItem onClick={handleClose}><Link to="2021">2021</Link></MenuItem>
                            </Menu>
                        </li>
                        <li><Link className={location.pathname === '/hall-of-fame' ? styles.active : null} to="hall-of-fame">Hall of Fame</Link></li>
                    </ul>
                </div>
            </div>
            <div style={{ backgroundColor: '#f0eee8ff' }}>
                <Outlet />
            </div>
        </div>
    );
}

export default App;
